const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.app.visitedViews,
  cachedViews: state => state.app.cachedViews,
  closedViews: state => state.app.closedViews,
  restoreViews: state => state.app.restoreViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  account: state => state.user.account,
  roles: state => state.user.roles,
  serverconst: state => state.user.serverconst,
  basedata: state => state.user.basedata,
  basedataMD5: state => state.user.basedataMD5,
  constMD5: state => state.user.constMD5,
  repairList: state => state.user.repairList
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js